import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import TriageWizard from "@/components/triage/TriageWizard";
import TriageIntroModal from "@/components/triage/TriageIntroModal";

export default function TriagePage() {
  const [searchParams] = useSearchParams();
  const [showIntro, setShowIntro] = useState(false);

  // Show intro modal only for new sessions (no sessionId param) and if not skipped permanently
  useEffect(() => {
    const sessionId = searchParams.get("sessionId");
    const hasSeenIntro = sessionStorage.getItem("triage_intro_seen");
    const skipIntroPermanently = localStorage.getItem("triage_intro_skip");
    
    if (!sessionId && !hasSeenIntro && !skipIntroPermanently) {
      setShowIntro(true);
    }
  }, [searchParams]);

  const handleStartAssessment = () => {
    sessionStorage.setItem("triage_intro_seen", "true");
    setShowIntro(false);
  };

  const handleSkipIntro = () => {
    // Permanently skip intro for this user
    localStorage.setItem("triage_intro_skip", "true");
    sessionStorage.setItem("triage_intro_seen", "true");
    setShowIntro(false);
  };

  return (
    <>
      <Helmet>
        <title>AI Symptom Checker for Hospitals - Emergency Room Triage App | CheckFirst</title>
        <meta name="description" content="Use our AI symptom checker for hospitals and emergency room triage app. Hospital triage automation with clinical decision support. Get instant healthcare guidance." />
        <meta name="keywords" content="AI symptom checker for hospitals, emergency room triage app, hospital triage automation, clinical decision support tool, virtual healthcare triage system, patient triage platform" />
        
        <meta property="og:title" content="AI Symptom Checker - Emergency Room Triage App" />
        <meta property="og:description" content="Use our AI symptom checker for hospitals and emergency room triage app. Hospital triage automation with clinical decision support." />
        <meta property="og:url" content="https://www.checkfirstcare.com/triage" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.checkfirstcare.com/og-image.jpg" />
        
        <meta name="twitter:title" content="AI Symptom Checker - Emergency Room Triage App" />
        <meta name="twitter:description" content="Use our AI symptom checker for hospitals and emergency room triage app. Hospital triage automation with clinical decision support." />
        
        <link rel="canonical" href="https://www.checkfirstcare.com/triage" />
      </Helmet>
      
      <TriageIntroModal open={showIntro} onStart={handleStartAssessment} onSkip={handleSkipIntro} />
      <TriageWizard />
    </>
  );
}